<template>
  <div id="income-container" class="flex income-container">
    <div class="left-content" :class="`w-${chart == 0 ? '2/3' : 'full'}`">
      <div class="w-full flex align-center justify-between mb-5 income-header">
        <div class="flex align-center">
          <div class="vx-breadcrumb">
            <ul class="flex flex-wrap items-center">
              <li class="inline-flex items-end">
                <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
              </li>
              <li class="inline-flex items-end">
                <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Income</span>
              </li>
            </ul>
          </div>
          <div class="flex align-center ml-6 button-group">
            <vs-button class="toggle-btn icon-btn" :class="{'active' : chart == 0}" @click="toggleChartView(0)">
              <img src="../../assets/images/primary-list-icon.svg" v-if="chart == 1" />
              <img src="../../assets/images/white-list-icon.svg" v-else />
            </vs-button>
            <vs-button class="toggle-btn icon-btn" :class="{'active' : chart == 1}" @click="toggleChartView(1)">
              <img src="../../assets/images/primary-bar-chart-icon.svg" v-if="chart == 0" />
              <img src="../../assets/images/white-bar-chart-icon.svg" v-else />
            </vs-button>
          </div>
        </div>
        <div class="flex align-center">
          <div class="flex-center date-filter">
            <date-picker class="ml-5 filter-year-picker" :disabled-date="disabledRange" v-model="year_filter" @change="getData" type="year" :editable="false" :clearable="false" placeholder="Year" v-if="view_by.type == 'week' || view_by.type == 'month'"></date-picker>
            <date-picker class="ml-5 filter-date-picker" :disabled-date="disabledRange" v-model="date_filter" @change="getData" :format="date_format_string" range-separator="  to  " range type="date" :editable="false" :clearable="false" placeholder="From date to date" v-if="view_by.type == 'day'"></date-picker>
          </div>
          <div class="view-by-select ml-5">
            <v-select @input="changeViewType($event)" :value="view_by" label="title" :options="viewOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
          </div>
          <vs-button class="gradient gradient-primary no-shadow export-btn sm:ml-5 ml-0" @click="exportData">
              <div class="flex-center">
                  <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                  Export
              </div>
          </vs-button>
        </div>
      </div>

      <div class="position-relative overflow-hidden main-content">
        <vs-table :data="incomeList" v-if="chart == 0">
          <template slot="thead">
            <vs-th class="center-title text-center">{{ view_by.table_title }}</vs-th>
            <vs-th class="center-title text-center">INCOME</vs-th>
            <!-- <vs-th class="center-title text-center">ACTION</vs-th> -->
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="item" v-for="(item, index) in data" :key="index" class="shadow-md" :class="{'active': activeItem && activeItem.title == item.title}" @click.native="activeItem = item">
              <vs-td class="text-center">{{ item.title }}</vs-td>
              <vs-td class="text-center">${{ item.income }}</vs-td>
              <!-- <vs-td class="text-center">
                <vs-button class="print-btn" :class="`text-${activeItem && activeItem.title == item.title ? 'white' : 'primary'}`">
                  <img src="../../assets/images/white-printer.png" class="printer-icon" v-if="activeItem && activeItem.title == item.title" />
                  <img src="../../assets/images/primary-printer.png" class="printer-icon" v-else />
                  Print
                </vs-button>
              </vs-td> -->
            </vs-tr>
          </template>
        </vs-table>

        <div class="w-full overflow-auto" v-else>
          <div class="flex-center translate-center" style="top: 8px;">
            <div style="width: 40px; height: 15px; background: #1E4FA0"></div>
            <div class="ml-2 text-sm" style="font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif">Income</div>
          </div>
          <line-chart :chartInfo="chartInfo" :isFromSalaryChart="true" :isFromIncome="true" class="w-full mt-12" :style="`min-width: calc(70px * ${incomeList.length - 1})`" :key="chart_key"></line-chart>
        </div>
      </div>
    </div>
    <div class="w-1/3 pl-5 right-content" v-if="chart == 0">
      <vx-card class="w-full no-shadow text-black">
        <div class="pb-2">
          <h5 class="text-uppercase font-bold income-detail-title py-2 px-custom pb-0">Income Preview</h5>
          <div v-if="activeItem">
            <p class="text-sm px-custom mb-2" v-if="view_by.type == 'day'">Date: {{ activeItem.title }}</p>
            <div class="px-custom small-height-hidden" :class="{'day-view': view_by.type == 'day'}">
              <div v-if="view_by.type == 'day'">
                <div class="flex">
                  <div class="w-1/3">OD</div>
                  <div class="w-5/12">CUSTOMER</div>
                  <div class="w-1/4 text-right">INCOME</div>
                </div>
                <div class="dotted-line"></div>

                <div class="hidden-con" :class="{ 'has-service-fee': activeItem.summary && activeItem.summary.service_fee }">
                  <div class="w-full h-full overflow-auto">
                    <div class="py-2" v-if="activeItem.batches && activeItem.batches.length > 0">
                      <div class="flex py-05" v-for="(item, index) in activeItem.batches" :key="index">
                        <div class="w-1/3">{{ item.order_id }}</div>
                        <div class="w-5/12 staff-name">{{ item.customer_name }}</div>
                        <div class="w-1/4 text-right">${{ formatAmountNum(item.subtotal) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dotted-line" :class="{'mt-4': view_by.type != 'day'}"></div>
              <div v-if="activeItem.summary">
                <div class="py-2">
                  <div class="flex py-05">
                    <div class="w-1/2">Card</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.card_amount) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">External Credit Card</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.external_cc_amount) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Cash</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.cash_amount) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Check</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.check_amount) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Giftcard</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.giftcard_amount) }}</div>
                  </div>
                  <!-- <div class="flex py-05">
                    <div class="w-1/2">ACH</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.ach_amount) }}</div>
                  </div> -->
                  <div class="flex py-05">
                    <div class="w-1/2">Change</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.change) }}</div>
                  </div>
                </div>
                <div class="dotted-line"></div>
                <div class="py-2">
                  <div class="flex py-05">
                    <div class="w-1/2">Sub-total:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.subtotal) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Tax:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.tax) }}</div>
                  </div>
                  <div class="flex py-05" v-if="activeItem.summary.service_fee">
                    <div class="w-1/2">Service fee:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.service_fee) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Total tip:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.tip) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Cash Discount:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.cash_discount) }}</div>
                  </div>
                  <div class="flex py-05" v-if="activeItem.summary.discount_item || activeItem.summary.discount_item === 0">
                    <div class="w-1/2">Total Discount Item:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.discount_item) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Total Discount:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.discount) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Total Redeem:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.redeem) }}</div>
                  </div>
                  <div class="flex py-05">
                    <div class="w-1/2">Giftcard Price:</div>
                    <div class="w-1/2 text-right">${{ formatAmountNum(activeItem.summary.giftcard_price) }}</div>
                  </div>
                </div>

                <div class="solid-line"></div>

                <div class="flex align-center justify-between mt-3 total-income">
                  <p class="text-primary">TOTAL INCOME</p>
                  <!-- <p class="text-primary">${{ formatAmountNum(activeItem.summary.income + activeItem.summary.tip + activeItem.summary.tax - activeItem.summary.cash_discount) }}</p> -->
                  <p class="text-primary">${{ formatAmountNum(activeItem.summary.total) }}</p>
                </div>
              </div>
            </div>
        </div>
        <div class="text-sm px-custom no-data-con" v-else>
          No Selected Data
        </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import moment from 'moment';
import { formatDateString } from '../../helper/datetimeHelper';
export default {
  components: { DatePicker, vSelect },
  data() {
    let date_format_string = formatDateString();
    return {
      chart: 0,
      year_filter: new Date(),
      date_filter: [new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1), new Date()],
      viewOptions: [
        { type: "day", title: 'Day', table_title: 'DATE' },
        { type: "week", title: 'Week', table_title: 'WEEK' },
        { type: "month", title: 'Month', table_title: 'MONTH' },
        { type: "year", title: 'Year', table_title: 'YEAR' }
      ],
      view_by: { type: "day", title: 'Day', table_title: 'DATE' },
      date_format_string,
      filterObject: {
        start_date: "2021-03-03", // required for day view
        end_date: "2021-06-06", // required for day view
        year: "2021", // required for week & month view
        type: "day", // day || week || month || year
        chart: 0, // 0 not chart data || 1 chart data
      },
      activeItem: null,
      isOpenLoading: false,
      chart_key: 0,
      chartInfo: {},
      headerTitle: ["Card", "External Credit Card", "Cash", "Check", "Giftcard", "Change", "Sub-total", "Tax", "Total tip", "Cash Discount", "Total Discount Item", "Total Discount", "Total Redeem", "Total Income"],
      headerVal: ["title", "card_amount", "external_cc_amount", "cash_amount", "check_amount", "giftcard_amount", "change", "subtotal", "tax", "tip", "cash_discount", "discount_item", "discount", "redeem", "total"],
    };
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
          clearTimeout(this.loadTime);
          this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Get data failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    disabledRange(date) {
      return date > new Date();
    },
    formatAmountNum(amount) {
      if(amount) {
        return parseFloat(amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
      return '0.00';
    },
    getData() {
      // let filterObject = {
      //   start_date: "2021-03-03", // required for day view
      //   end_date: "2021-06-06", // required for day view
      //   year: "2021", // required for week & month view
      //   type: "day", // day || week || month || year
      //   chart: 0, // 0 not chart data || 1 chart data
      // }
      let filterObject = {
        type: this.view_by.type,
        chart: this.chart
      }
      if(this.view_by.type == 'day') {
        filterObject.start_date = this.date_filter && this.date_filter[0] ? 
          moment(this.date_filter[0]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
        filterObject.end_date = this.date_filter && this.date_filter[1] ? 
          moment(this.date_filter[1]).format('YYYY-MM-DD') : filterObject.start_date;
      }
      if(this.view_by.type == 'week' || this.view_by.type == 'month') {
        filterObject.year = this.year_filter ? moment(this.year_filter).format('YYYY') : moment(new Date()).format('YYYY');
      }
      this.openLoadingInDiv();
      this.$store.dispatch("goPos/GET_INCOME_HISTORY", filterObject).then(() => {
        let data = this.$store.getters["goPos/incomeHistory"];
        this.activeItem = data && data[0] ? data[0] : null;
        if(this.chart == 1) {
          this.initChartData(data);
          this.chart_key++;
        }
        this.closeLoading();
      }).catch((err) => {
        console.log("Error: ", err);
      });
    },
    toggleChartView(type) {
      this.chart = type;
      this.getData();
    },
    changeViewType(e) {
      this.view_by = JSON.parse(JSON.stringify(e));
      this.getData();
    },
    initChartData(data) {
      let datasets = [];
      let labels = [];
      let dataset_item = {
        backgroundColor: "rgb(30, 79, 160)",
        data: [],
        label: "Income"
      }
      if(data && data.length > 0) {
        for(let i = 0; i < data.length; i++) {
          labels.push(data[i].title);
          dataset_item.data.push(data[i].income);
        }
        datasets.push(dataset_item);
        this.chartInfo = {
          datasets: datasets,
          labels: labels
        }
      }
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
            return v[j]
        }))
    },
    exportData() {
      import('@/vendor/Export2Excel').then(excel => {
          const list = this.exportDataList
          const data = this.formatJson(this.headerVal, list)
          
          let tempHeaderTitle = Array.from(this.headerTitle);
          tempHeaderTitle.unshift(this.view_by.table_title);
          excel.export_json_to_excel({
              header: tempHeaderTitle,
              data,
              filename: "Store Income by " + this.view_by.table_title,
              bookType: "xlsx",
          })
      });
    }
  },
  computed: {
    incomeList() {
      // console.log(this.$store.getters["goPos/incomeHistory"]);
      return this.$store.getters["goPos/incomeHistory"];
    },
    exportDataList() {
      if(this.incomeList) {
          return this.incomeList.map((item) => {
              return {
                  ...item.summary,
                  title: item.title,
              }
          })
      }
      return [];
    }
  },
  created() {
    this.getData();
  },
};
</script>